'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _rollupPluginBabelHelpers = require('../../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var classNames = _interopDefault(require('classnames/dedupe'));
var Img = require('../../01.atoms/Img/Img.js');
require('./_index.scss.js');

var _excluded = ["alt"];
var CLASSNAME = 'varta-collage',
    cnMirror = "".concat(CLASSNAME, "--mirror"),
    cnRow = "".concat(CLASSNAME, "__row"),
    cnCol = "".concat(CLASSNAME, "__col"),
    cnImage = "".concat(CLASSNAME, "__image");
/**
 * 
 * @returns 
 */

function Collage(_ref) {
  var animate = _ref.animate,
      className = _ref.className,
      images = _ref.images,
      mirror = _ref.mirror;
  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames(CLASSNAME, className, _rollupPluginBabelHelpers.defineProperty({}, cnMirror, mirror))
  }, /*#__PURE__*/React__default.createElement("div", {
    className: cnRow
  }, images.map(function (image, i) {
    var alt = image.alt,
        srcs = _rollupPluginBabelHelpers.objectWithoutProperties(image, _excluded);

    return /*#__PURE__*/React__default.createElement("div", {
      className: cnCol,
      key: i
    }, /*#__PURE__*/React__default.createElement(Img, {
      srcset: srcs,
      alt: alt,
      className: cnImage,
      animate: animate
    }));
  })));
}
Collage.propTypes = {
  /** Add scroll-in animation to images */
  animate: PropTypes.bool,

  /** Additional class name */
  className: PropTypes.string,

  /** Array of images */
  images: PropTypes.arrayOf(PropTypes.shape({
    xs: PropTypes.string.isRequired,
    alt: PropTypes.string
  })).isRequired,

  /** Switch order of images */
  mirror: PropTypes.bool
};
Collage.defaultProps = {
  images: []
};

module.exports = Collage;
